export default "__VITE_ASSET__0e5e5fe5__"